import React, { useEffect, useMemo, useState } from "react";
import "./Step4BillContainer.css";
import WalletIcon from "../../../../../assets/icons/wallet.svg";
import { useDispatch, useSelector } from "react-redux";
import { stepsActions } from "../../../../../store/steps-slice";
import { PuffLoader } from "react-spinners";
import { Box, Checkbox, Stack, Typography } from "@mui/material";
import UNIVERSAL from "../../../../../config/config";

const Step4BillContainer = ({ step4Spinner, userData, setUseWallet, useWallet }) => {
  const [businessInfo, setBusinessInfo] = useState("");
  const campaigns = useSelector((state) => state.campaigns.data);
  const user = useSelector((state) => state.user.user);

  const dispatch = useDispatch();

  const step4Data = useSelector((state) => state.steps.step4Data);

  useEffect(() => {
    async function getBrandData() {
      return fetch(UNIVERSAL.BASEURL_2 + "/user/api/v1/business/info", {
        method: "POST",
        body: JSON.stringify({
          business_id: user?.app_business_id,
        }),
      })
        .then((response) => response.json())
        .then((responseJson) => {
          if (responseJson?.data?.brand_name === null || responseJson?.data?.brand_name?.length === 0) {
          } else {
            if (responseJson?.data) setBusinessInfo(responseJson.data);
          }
        })
        .finally(() => {})
        .catch((error) => {
          console.log(error);
        });
    }
    getBrandData();
  }, []);

  const gst = useMemo(() => {
    if (useWallet) {
      if (userData?.credits > step4Data?.campaign_budget) {
        return 0;
      } else {
        return ((step4Data?.campaign_budget - userData?.credits) * 18) / 100;
      }
    } else {
      return (step4Data?.campaign_budget * 18) / 100;
    }
  }, [step4Data, useWallet, userData]);

  const totalAmount = useMemo(() => {
    if (useWallet) {
      if (userData?.credits > step4Data?.campaign_budget) {
        return 0;
      } else {
        return step4Data?.campaign_budget - userData?.credits + gst;
      }
    } else {
      return step4Data?.campaign_budget + gst;
    }
  }, [step4Data, gst, useWallet, userData]);

  const usedWalletAmount = useMemo(() => {
    if (!useWallet) return 0;
    if (userData?.credits > step4Data?.campaign_budget) return step4Data?.campaign_budget;
    return userData?.credits;
  }, [useWallet, step4Data]);

  useEffect(() => {
    if (totalAmount) {
      dispatch(stepsActions.setTotal(totalAmount));
    }
  }, [totalAmount, dispatch]);

  useEffect(() => {
    if (businessInfo?.source === "INTERAKT") {
      if (!campaigns?.length && userData?.credits >= 999) {
        setUseWallet(true);
      }
    }
  }, [campaigns, businessInfo?.source, userData?.credits]);

  const getIsDisabled = () => {
    if (businessInfo?.source === "INTERAKT") {
      if (!campaigns?.length && userData?.credits >= 999) {
        console.log("GETDISABLED");
        return true;
      }
    }
    return false;
  };

  return (
    <div id="step4BillContainer">
      <h6 className="step4BillContainer-heading">Your bill details</h6>
      <hr className="step4BillContainer-Hr" />
      {!step4Data || step4Spinner ? (
        <Stack direction="row" alignItems="center" justifyContent="center" py={2}>
          <PuffLoader size={64} color="#0F6EFF" />
        </Stack>
      ) : (
        <div className="step4BillConatinerCard">
          {userData?.credits > 0 && (
            <Box mb={3} mt={1} bgcolor="#F5F9FF" borderRadius={4} pl={1} pr={2} py={1.5} border="1px dashed #DAE6FF">
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Stack direction="row" gap={1} alignItems="center">
                  <Checkbox disabled={getIsDisabled()} checked={useWallet} onChange={(event) => setUseWallet(event.target.checked)} />
                  <Stack>
                    <Typography fontFamily="Gilroy" fontWeight={600} variant="body1">
                      Use wallet amount
                    </Typography>
                    <Stack direction="row" alignItems="center" gap={0.5}>
                      <Typography fontFamily="Gilroy" variant="body2">
                        Available amount:
                      </Typography>
                      <Typography fontFamily="Gilroy" variant="body1" fontWeight={600}>
                        ₹{userData?.credits}
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
                <img src={WalletIcon} height={48} width={48} />
              </Stack>
            </Box>
          )}
          <div
            className={`step4BillContainerCardHeading ${step4Data.plan_name === "Starter" && "step4BillContainerCardHeading-starter"} ${
              step4Data.plan_name === "Growth" && "step4BillContainerCardHeading-growth"
            }  ${step4Data.plan_name === "Scale" && "step4BillContainerCardHeading-scale"}`}
          >
            <div className="step4BillContainerCardHeading-heading">
              <span className="step4Bill-headingUpper">
                <img className="step4Bill-planType" src={step4Data.img2} alt="starter-img" />
                <p className="step4Bill-plan">plan</p>
              </span>
              <p className="step4Bill-planPrice">₹ {step4Data.campaign_budget}</p>
            </div>
            <p className="step4BillContainerCardHeading-subHeading" style={{ display: "none" }}>
              Reach <span className="step4Bill-npeople">{step4Data.campaign_target}</span> people / ad
            </p>
          </div>
          <div className="step4BillContainerCardBody">
            <span className="step4Bill-billDetails">
              <p className="step4Bill-billDetails-title">Facebook ads</p>
              <p className="step4Bill-billDetails-price">₹ {step4Data.campaign_budget}</p>
            </span>
            {useWallet && (
              <span className="step4Bill-billDetails">
                <p className="step4Bill-billDetails-title">Wallet</p>
                <p className="step4Bill-billDetails-price">- ₹ {usedWalletAmount}</p>
              </span>
            )}
            <span className="step4Bill-billDetails">
              <p className="step4Bill-billDetails-title">GST (18%)</p>
              <p className="step4Bill-billDetails-price">₹ {gst}</p>
            </span>
            <hr className="step4BillContainer-Hr2" />
            <span className="step4Bill-billDetails">
              <p className="step4Bill-billDetails-title">Amount to be paid</p>
              <p className="step4Bill-billDetails-price">
                ₹ <span className="step4Bill-billDetails-totalAmount">{totalAmount.toLocaleString()}</span>
              </p>
            </span>
            <span className="step4Bill-safeAndSecure">
              <img src="https://d1n7zmj0fa1o7h.cloudfront.net/instamojo-assets/lock.svg" alt="safe-secure-payment-icon" />
              <p className="step4Bill-safeAndSecure-info">Safe and secure payments. 100% authentic</p>
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default Step4BillContainer;
